import './MobileMenu.scss'
import CartModal from './Shop/CartModal';
import AuthModal from './Auth/AuthModal';
import { useAppContext } from '../services/app-context.service';
import UserMenuModal from './Auth/UserMenuModal';
import { IonIcon } from '@ionic/react';
import { menuOutline, headsetOutline } from 'ionicons/icons';
import AllCategoryModal, { allCategoryModalRef } from './Header/AllCategoryModal';
import { appSubDir } from '../configs/app';
import { Link } from 'react-router-dom';

const MobileMenu: React.FC = () => {
    const { user, cart } = useAppContext();

    const cartCount = cart && cart.items ? cart.items.reduce((sum, item) => sum + (item.quantity || 0), 0) : 0;

    return <>
        <nav id="bottom-menu">
            <div className="bottom-menu-item" onClick={() => allCategoryModalRef.current?.present()}>
                <IonIcon icon={menuOutline} />
                <span className="menu-label">Category</span>
            </div>
            
            <div className="bottom-menu-item cart-item-wrapper">
                <CartModal />
                {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
                <span className="menu-label">Cart</span>
            </div>
            
            <div className="bottom-menu-center">
                <Link to={appSubDir} className="center-logo-btn">
                    <img src="assets/icon/icon.webp" alt='Brand Logo' />
                </Link>
            </div>
            
            <a href="https://m.me/chinahubbd1" target="_blank" rel="noopener noreferrer" className="bottom-menu-item chat-item-wrapper">
                <IonIcon icon={headsetOutline} />
                <span className="menu-label">Chat</span>
            </a>
            
            <div className="bottom-menu-item">
                {user.token ? <UserMenuModal /> : <AuthModal />}
                <span className="menu-label">Account</span>
            </div>
        </nav>
        <AllCategoryModal />
    </>
};

export default MobileMenu;
